import { VStack } from "@chakra-ui/react"
import React from "react"
import { CreateZoneForm } from "../../forms"

export const CreateZone: React.FC = () => {
	return (
		<VStack w="full" spacing={6} maxW="sm">
			<CreateZoneForm />
		</VStack>
	)
}
